import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import App from './App';
import AboutUs from "./AboutUs";
import Leadership from "./Leadership";
import Investors from "./Investors";
import HowItWorks from "./HowItWorks";
import InvestmentCase from "./InvestmentCase";
import ESG from "./ESG";
import Environment from "./Environment";
import Community from "./Community";
import Governance from "./Governance";
import Journey from "./Journey";
import ContactUs from "./ContactUs";
import Results from "./Results";
import MissingPage from "./MissingPage";
import RegulatoryNews from "./RegulatoryNews";
import ShareholderInfo from "./ShareholderInfo";
import AIMRule from "./AIMRule";
import React, {Component} from "react";
import Careers from "./Careers";
import EmailSignUp from "./EmailSignUp";
import CookieConsent from "react-cookie-consent";
import "./App.css";
import IPODocuments from "./IPODocuments";
import ScrollToTop from "./Tools/ScrollToTop";
import FinancialCalendar from "./FinancialCalendar";
import Research from "./Research";
import Press from "./Press";

class Wrapper extends Component{
    constructor(props) {
        super(props);
        this.state = { check: false };

        this.mobileAndTabletCheck = this.mobileAndTabletCheck.bind(this);
    }

    mobileDoubleCheck = () => {
        let doubleCheck = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) doubleCheck = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return doubleCheck;
    };


    mobileAndTabletCheck = () => {
        if(window.innerWidth < 960 || this.mobileDoubleCheck()){
            this.setState({ check: true });
        }
        else {
            this.setState({ check: false });
        }
    }

    componentDidMount() {
        this.mobileAndTabletCheck();
        window.addEventListener('resize', this.mobileAndTabletCheck.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.mobileAndTabletCheck.bind(this));
    }

    openInNewTab = (url) => {
        const newWindow = window.open();
        newWindow.location = url;
    }

    render() {
        return (
            <div className="wrapper">
                <CookieConsent
                    style={{ background: "#454545", 'padding-left': '3%', 'padding-right': '3%' }}
                    buttonStyle={{background: "#FFFFF", 'font-family': "GalanoGrotesque-Regular"}}
                ><text className='cookieText'>We use cookies on our site to ensure we give you the best experience possible. By continuing to browse the site, you consent to our use of cookies. <button className='findOutMore' onClick={() => this.openInNewTab("https://markselectrical.co.uk/cookies.html")}>Find out more.</button></text></CookieConsent>
                <Router>
                    <ScrollToTop />
                    <Switch>
                        <Route path="/about" component={AboutUs}>
                            <AboutUs mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/leadership" component={Leadership}>
                            <Leadership mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/investors" component={Investors}>
                            <Investors mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/howitworks" component={HowItWorks}>
                            <HowItWorks mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/investmentcase" component={InvestmentCase}>
                            <InvestmentCase mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/esg" component={ESG}>
                            <ESG mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/environment" component={Environment}>
                            <Environment mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/community" component={Community}>
                            <Community mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/governance" component={Governance}>
                            <Governance mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/journey" component={Journey}>
                            <Journey mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/contact" component={ContactUs}>
                            <ContactUs mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/results" component={Results}>
                            <Results mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/regulatorynews" component={RegulatoryNews}>
                            <RegulatoryNews mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/shareholder" component={ShareholderInfo}>
                            <ShareholderInfo mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/aim26" component={AIMRule}>
                            <AIMRule mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/careers" component={Careers}>
                            <Careers mobileSite={this.state.check}/>
                        </Route>
                        <Route path="/signup" component={EmailSignUp}>
                            <EmailSignUp mobileSite={this.state.check}/>
                        </Route>
                        <Route exact path="/">
                            <App mobileSite={this.state.check}/>
                        </Route>
                        <Route exact path="/ipo">
                            <IPODocuments mobileSite={this.state.check}/>
                        </Route>
                        <Route exact path="/financialcalendar">
                            <FinancialCalendar mobileSite={this.state.check}/>
                        </Route>
                        <Route exact path="/research">
                            <Research mobileSite={this.state.check}/>
                        </Route>
                        <Route exact path="/press">
                            <Press mobileSite={this.state.check}/>
                        </Route>
                        <Route exact path="*">
                            <MissingPage mobileSite={this.state.check}/>
                        </Route>
                    </Switch>
                </Router>
            </div>
        );
    }
}

export default Wrapper;